// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { HttpClientInstance } from "@toggl/sync/http";
import { Attachment } from "../types";
import { toFormData } from "../utils/requests";

export async function deleteAttachment(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  attachment_id: number,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .delete(`jobopenings/${job_opening_slug}/attachments/${attachment_id}`, {
      signal,
    })
    .json<unknown>();
  return response;
}

export async function postAttachments(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  file_type: string,
  upload: File,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`jobopenings/${job_opening_slug}/attachments/${file_type}`, {
      signal,
      body: toFormData({ upload }),
    })
    .json<Attachment>();
  return response;
}

export async function postQuestionAttachments(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  test_slug: string,
  question_id: string,
  upload: File,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(
      `jobopenings/${job_opening_slug}/tests/${test_slug}/questions/${question_id}/attachments`,
      { signal, body: toFormData({ upload }) },
    )
    .json<Attachment>();
  return response;
}
